module.exports = __webpack_public_path__ + "static/media/IMG_1463.61d13fc2.jpg";